import { logger } from './logger';

export const DEVICE_KEY_SUFFIXES = [
  'deviceKey',
  'deviceGroupKey',
  'randomPasswordKey',
] as const;

export const clearCognitoDeviceKeys = (clientId: string, username: string): void => {
  const prefix = `CognitoIdentityServiceProvider.${clientId}.${username}`;

  logger.warn(`Clearing stale Cognito device keys for ${username}`);

  for (const suffix of DEVICE_KEY_SUFFIXES) {
    localStorage.removeItem(`${prefix}.${suffix}`);
  }
};
